import { bem, bm } from '@core-utils/bem';
import styles from './DialogModal.module.scss';

export const modalZoneStyles = {
    blockScope: styles.DialogModalZone,
}

export const modalStyles = {
    blockScope: styles.DialogModal,
    blockScopeLarge: styles[bm('DialogModal', 'large')],
    blockScopeMedium: styles[bm('DialogModal', 'medium')],
    blockScopeSmall: styles[bm('DialogModal', 'small')],
    header: styles[bem('DialogModal', 'header')],
    content: styles[bem('DialogModal', 'content')],
    footer: styles[bem('DialogModal', 'footer')],
    closeButton: styles[bem('DialogModal', 'closeButton')],
}